import React from 'react'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import './stepper.css'
import { useNavigate } from "react-router-dom";

const steps = [
  {
    title: "Wedding Details",
    path: "/details",
  },
  {
    title: "Events",
    path: "/events",
  },
  {
    title: "Preview",
    path: "/preview",
  },
  {
    title: "Share Your Invitation",
    path: "/share",
  },
];


const Stepper = ({step,demoVersion}) => {
  const navigate = useNavigate();

    const handleNext = () => {
        if (step < steps.length) {
            navigate(steps[step].path);
        }
    };

    const handleBack = () => {
        if (step > 1) {
            navigate(steps[step - 2].path);
        }
    };

  return (
     <div className="stepper"     style={{
        marginTop: demoVersion ? "70px" : "10px",
      }}>

      <button
        className="stepper-btn"
        onClick={handleBack}
        disabled={step === 1}
      >
        <ArrowBackIosIcon fontSize="small" />
      </button>

      <div className="stepper-center">
        {/* <p className="stepper-count">
          Step {step}/{steps.length}
        </p> */}

        <h2 className="stepper-title">
          {steps[step - 1].title}

        </h2>
      </div>

      <button
        className="stepper-btn"
        onClick={handleNext}
        disabled={step === 4}
      >
        <ArrowForwardIosIcon fontSize="small" />
      </button>

    </div>
  )
}

export default Stepper